import * as React from 'react'

import {
  TextField
} from '@mui/material'

import { styled } from '@mui/material/styles';

const CTextField = styled(TextField)({
  borderRadius: 16, 
  '>.MuiInputBase-root': {
    borderRadius: 16
  }
});

export {
  CTextField
}